<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="accountName">
        <span slot="label"><a-tooltip>{{ $t('结算账户名') }}<template slot="title">{{ $t('持卡人姓名') }}</template></a-tooltip> </span>
        <a-input v-model="form.accountName" :maxLength="256" :placeholder="$t('请输入')+'结算账户名'">
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="accountNo">
        <span slot="label"><a-tooltip>{{ $t('银行卡号') }}<template slot="title">{{ $t('银行卡号') }}</template></a-tooltip> </span>
        <a-input v-model="form.accountNo" :maxLength="128" :placeholder="$t('请输入')+'银行卡号'">
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="accountBankName"  >
        <span slot="label" ><a-tooltip>{{$t('银行名称')}}<template slot="title">开户银行,输入并搜索</template></a-tooltip></span>
        <a-auto-complete class="global-search"  v-model="form.accountBankName"  style="width: 100%" placeholder="请输入开户银行查询" option-label-prop="title"
                         @select="handleBankChange"
                         @search="handleBankSearch">
          <template slot="dataSource">
            <a-select-option v-for="item in bankList" :key="item.bankName" :title="item.bankName">
              {{ item.bankName }}
            </a-select-option>
          </template>
        </a-auto-complete>
      </a-form-model-item>
      <a-form-model-item prop="accountBankBranchCode" :disabled="formType===2">
        <span slot="label"><a-tooltip>{{ $t('银行支行') }}<template slot="title">{{ $t('开户支行') }}</template></a-tooltip></span>
        <a-button @click="openBranchSelect" style="text-align: left; width: 100%">
          {{ this.getBranchName() }}
        </a-button>
      </a-form-model-item>
      <a-form-model-item class="margin-bottom-10" :label="$t('是否默认')" prop="isDefault">
        <a-radio-group v-model="form.isDefault" button-style="solid">
          <a-radio-button v-for="(item, index) in this.customDict.TFEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
    <radio-branch-select-form ref="RadioBranchSelectForm" @branchSelect="indexBranchSelect"></radio-branch-select-form>
  </a-drawer>
</template>

<script>
import {getBankAccount, addBankAccount, updateBankAccount} from '@/api/merchant/bankAccount'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import LocaleFieldButton from "@/components/locale/LocaleFieldButton.vue";
import {listBank} from "@/api/merchant/bank";
import RadioBranchSelectForm from "@/views/merchant/branch/modules/RadioSelectForm.vue";


export default {
  name: 'CreateForm',
  props: {},
  components: {
    RadioBranchSelectForm,
    CustomDictTag,
    LocaleFieldButton,
  },
  data() {
    return {
      labelCol: {span: 4},
      wrapperCol: {span: 14},
      submitLoading: false,
      formTitle: '',
      loading: '',
      bankList: [],
      // 表单参数
      form: {
        id: null,
        merchantId: null,
        accountName: null,
        accountBankName: null,
        accountNo: null,
        accountBankBranchCode: null,
        accountBankBranchName: null,
        isDefault: true,
        deptId: null,
        localeFieldMap: {},
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        accountName: [{required: true, message: this.$t('持卡人姓名') + this.$t('不能为空'), trigger: 'blur'}],
        accountBankName: [{required: true, message: this.$t('银行名称') + this.$t('不能为空'), trigger: 'blur'}],
        accountNo: [{required: true, message: this.$t('银行卡号') + this.$t('不能为空'), trigger: 'blur'}],
        accountBankBranchCode: [{required: true, message: this.$t('银行卡号') + this.$t('不能为空'), trigger: 'change'}],
        isDefault: [{required: true, message: this.$t('是否默认 1:是,0:否') + this.$t('不能为空'), trigger: 'blur'}],
        deptId: [{required: true, message: this.$t('所属部门') + this.$t('不能为空'), trigger: 'blur'}]
      }
    }
  },
  filters: {},
  created() {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.cancel()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        merchantId: null,
        accountName: null,
        accountBankName: null,
        accountNo: null,
        accountBankBranchCode: null,
        accountBankBranchName: null,
        isDefault: true,
        localeFieldMap: {},
      }

    },


    //银行选择
    handleBankSearch(value) {
      if (value === undefined) {
        return;
      }
      if (value === '') {
        return;
      }
      listBank({"bankAlias": value}).then(response => {
        this.bankList = response.data
      })
    },
    handleBankChange(value) {
      console.log('搜索选中了银行信息:',value)
      this.form.accountBankName = value;
    },
    openBranchSelect () {
      this.$refs.RadioBranchSelectForm.openBranch(this.form.accountBankName, this.form.accountBankBranchCode, undefined);
    },
    indexBranchSelect(record) {

      this.form.accountBankBranchCode = record.code;
      this.form.accountBankBranchName = record.name;

      //自动选择地址
      this.form.accountBankAreaId=record.cityCode
      this.citySelected.push(record.cityCode.substring(0,2)+'0000')
      this.citySelected.push(record.cityCode)
    },
    getBranchName() {
      if (this.form.accountBankBranchCode) {
        return this.form.accountBankBranchName
      } else {
        return this.$t('请选择')+this.$t('商家账户.开户支行')
      }
    },

    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getBankAccount({"id": id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateBankAccount(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addBankAccount(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>